'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _universalIntl = require('@alife/universal-intl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var omit = function omit(obj, toDelete) {
  var re = _extends({}, obj);

  toDelete.forEach(function (prop) {
    return delete re[prop];
  });

  return re;
};

exports.default = function (messages, intlName) {
  return function (WrappedComponent) {
    var _class, _temp;

    return _temp = _class = function (_PureComponent) {
      _inherits(_class, _PureComponent);

      function _class(props) {
        _classCallCheck(this, _class);

        var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props));

        _this.getTranslations = function () {
          var keys = Object.keys(messages);

          return keys.reduce(function (result, key) {
            return _extends({}, result, _defineProperty({}, key, function (params) {
              return _this.translate(key, params);
            }));
          }, {});
        };

        _this.translate = function (id, params) {
          var message = messages[id];

          if (!message) {
            throw new Error('Please define your message with field: "' + id + '". All defined messages: ', messages);
          }
          return _this.intl.formatMessage(message, params);
        };

        _this.intl = (0, _universalIntl.injectIntl)({ name: intlName });
        return _this;
      }

      _createClass(_class, [{
        key: 'render',
        value: function render() {
          return _react2.default.createElement(WrappedComponent, _extends({
            translations: this.getTranslations()
          }, this.props, {
            translate: this.translate
          }));
        }
      }]);

      return _class;
    }(_react.PureComponent), _class.displayName = 'withI18n(' + WrappedComponent.name + ')', _class.propTypes = omit(WrappedComponent.propTypes, ['translate']), _class.defaultProps = WrappedComponent.defaultProps, _temp;
  };
};